import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSectionmaster,
  selectSectionmaster,
  setDataSuccess
} from 'src/features/staticDataSlice';
import { checkPermission } from 'src/utils/permission';
import SectionCreateModal from 'src/pages/SectionSettings/SectionCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function SectionmasterList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [sectionCreatePermission, setSectionCreatePermission] = useState(false);

  const sectionmasterData = useSelector(selectSectionmaster);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setSectionCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('section', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchSectionmaster(productId).then(data =>
      dispatch(setDataSuccess({ dataType: 'sectionMaster', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation logic if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel
          id={`select-label-section`}
          error={error}
        >
          {label}
        </StyledInputLabel>
        <Select
          labelId={`select-label-section`}
          id={`select-section`}
          value={tableListDatas[index]?.section || ''}
          onChange={(event) => {
            handleChange('section', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {sectionmasterData.map((section) => (
            <MenuItem key={section?.sectionName} value={section?.sectionName}>
              {section?.sectionName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              sectionCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Section
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (sectionCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: sectionCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <SectionCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default SectionmasterList;
